import { AsyncPipe, NgForOf } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormFieldModule } from '../wrapper/form-field/form-field.component';
import { CyTestDirective } from '@portal/directive';
import { PortalFieldTypeConfig } from '@portal/form/data-access';

@Component({
  selector: 'portal-form-radio',
  standalone: true,
  imports: [NgForOf, AsyncPipe, FormlyModule, FormlySelectModule, MatRadioModule, ReactiveFormsModule, CyTestDirective],
  template: `
    <mat-radio-group
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="props.required || false"
    >
      <mat-radio-button
        class="field-radio"
        [portalCyTest]="field.key"
        *ngFor="let option of props.options | formlySelectOptions: field | async; let i = index"
        [id]="id + '_' + i"
        [color]="defaultOptions.props.color"
        [labelPosition]="defaultOptions.props.labelPosition"
        [disabled]="disabled || option.disabled"
        [value]="option.value"
      >
        {{ option.label }}
      </mat-radio-button>
    </mat-radio-group>
  `,
  styles: [
    `
      :host {
        @apply block mt-2;
      }

      ::ng-deep .mat-radio-group {
        @apply flex flex-col items-start gap-2;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent extends FieldType<PortalFieldTypeConfig> {
  override defaultOptions = { props: { color: 'primary' as const, labelPosition: 'after' as const } };

  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }
}

@NgModule({
  imports: [
    FormFieldModule,
    FormlyModule.forChild({
      types: [{ name: 'radio', component: RadioComponent, wrappers: ['form-field'] }],
    }),
  ],
})
export class FormRadioModule {}
